"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _Icon = require("./Icon.styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Icon = function Icon(props) {
  var classes = (0, _Icon.useStyles)({
    position: props.position,
    variant: props.wrapVariant,
    onClick: props.onClick
  });
  if (!props.wrap) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.children);
  }
  return /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: classes.root,
    onClick: props.onClick
  }, props.children);
};
exports.Icon = Icon;